import axios, { AxiosResponse } from 'axios';
import router from '@/router/router';
import AccountService from '@/account/account.service';
import type { Router } from 'vue-router';
import { useAccountStore } from '@/stores/account';

export default class LoginService {
  constructor(private accountService: AccountService, private router: Router) {}

  public openLogin(instance: Vue): void {
    router.push('/login').catch(() => {});
  }

  public logout(): void {
    localStorage.removeItem('techpubs-accessToken');
    sessionStorage.removeItem('techpubs-accessToken');
    document.cookie = 'techpubs-session=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';

    const accountStore = useAccountStore();
    accountStore.logout();

    this.apiLogout().then(response => {
      router.push('/').catch(() => {});
    });
  }

  /** Po przejściu na JWT nie ma znaczenia */
  public apiLogout(): Promise<AxiosResponse<any>> {
    return axios.post('api/logout');
  }

  public impersonate(userLogin: string): Promise<boolean> {
    return new Promise(resolve => {
      const params = new URLSearchParams();
      params.append('username', userLogin);
      sessionStorage.setItem('impersonate-return-url', this.router.currentRoute.value.fullPath);
      axios
        .post('/api/authentication/impersonate', params)
        .then(response => {
          this.router.push('/').catch(() => {});
          this.accountService.retrieveAccount().then(accountDetailsRefreshed => {
            if (accountDetailsRefreshed) {
              resolve(true);
            } else {
              this.logout();
              resolve(false);
            }
          });
        })
        .catch(e => {
          console.error(e);
          this.logout();
          resolve(false);
        });
    });
  }

  public exitImpersonate(): Promise<boolean> {
    console.debug('exit impersonate called');
    return new Promise(resolve => {
      axios
        .post('/api/logout/impersonate')
        .then(response => {
          this.accountService.retrieveAccount().then(accountDetailsRefreshed => {
            if (accountDetailsRefreshed) {
              const returnUrl = sessionStorage.getItem('impersonate-return-url') ?? '/admin/user-management';
              sessionStorage.removeItem('impersonate-return-url');
              this.router.push(returnUrl).catch(() => {
                this.router.push('/admin/user-management').catch(() => {});
              });
              resolve(true);
            } else {
              this.logout();
              resolve(accountDetailsRefreshed);
            }
          });
        })
        .catch(e => {
          console.error('Exit impersonate failed', e);
          this.logout();
          resolve(false);
        });
    });
  }
}
